<template>
  <div style="display: contents;">
  <v-dialog v-model="dialogOpen"
    v-if="dialogOpen"
    persistent
    max-width="550"
    content-class="change-receipt-type-dialog"
    @keydown.esc="close">
    <v-card class="glass-card-receipt-type">
      <v-card-title class="glass-header-receipt-type pa-0">
        <v-row class="ma-0 pa-4 align-center">
          <v-col cols="auto" class="pa-0">
            <v-icon color="white" size="28">mdi-receipt-text</v-icon>
          </v-col>
          <v-col class="pa-0 pl-3">
            <h3 class="white--text" style="font-weight: 600; font-size: 18px; letter-spacing: 0.3px;">
              {{ $t("$vuetify.formDetails.changeReceiptType") }}
            </h3>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto" class="pa-0">
            <v-icon large color="white" @click="close">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text class="pt-4 px-4 pb-2">
        <!-- Customer Information Display (if R1) -->
        <div v-if="receipt && receipt.type && receipt.type.flag === 'R'" class="customer-info-section mb-4">
          <div class="customer-info-label">Podaci o kupcu</div>
          <div class="customer-info-card">
            <v-row class="ma-0">
              <v-col cols="12" class="pa-2">
                <div class="info-label">OIB</div>
                <div class="info-value">{{ receipt.type.payer_oib }}</div>
              </v-col>
              <v-col cols="12" class="pa-2">
                <div class="info-label">Kupac</div>
                <div class="info-value">
                  {{ receipt.type.payer_name.toUpperCase() }},
                  {{ receipt.type.payer_city ? receipt.type.payer_city.toUpperCase() : "" }},
                  {{ receipt.type.payer_country ? receipt.type.payer_country.toUpperCase() : "" }}
                </div>
              </v-col>
            </v-row>
            <v-btn
              small
              outlined
              color="primary"
              class="edit-customer-btn mt-2"
              @click="changeToR1"
            >
              <v-icon left small>mdi-pencil</v-icon>
              Promijeni podatke
            </v-btn>
          </div>
        </div>

        <!-- Receipt Type Selection -->
        <div class="receipt-type-label">Oznaka računa</div>
        <v-radio-group v-model="receiptType" @change="changeReceiptType" class="receipt-type-radio">
          <v-radio
            label="R1 - Nominativni račun"
            value="R"
            color="primary"
            class="receipt-radio-item"
          >
            <template v-slot:label>
              <div class="radio-label-content">
                <v-icon color="primary" class="mr-2">mdi-account-circle</v-icon>
                <div>
                  <div class="radio-title">R1 - Nominativni račun</div>
                  <div class="radio-subtitle">S OIB-om i podacima kupca</div>
                </div>
              </div>
            </template>
          </v-radio>
          <v-radio
            label="Bez oznake"
            value="BO"
            color="primary"
            class="receipt-radio-item"
          >
            <template v-slot:label>
              <div class="radio-label-content">
                <v-icon color="primary" class="mr-2">mdi-receipt</v-icon>
                <div>
                  <div class="radio-title">Bez oznake</div>
                  <div class="radio-subtitle">Račun bez podataka o kupcu</div>
                </div>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-card-text>

      <v-card-actions class="d-flex justify-end px-4 pb-4">
        <v-btn
          outlined
          color="primary"
          @click="close"
          class="cancel-btn-receipt-type"
          elevation="0"
        >
          Zatvori
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay v-if="loading" absolute z-index="10">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>

    <account-details-dialog-new ref="accountDetailsDialog"
      @refresh="refresh"
      @success="onSuccess"
      @show-snackbar="onShowSnackbar" />
  </v-dialog>
  <v-snackbar
    v-model="snackbar"
    :timeout="3000"
    color="success"
    top
    right
    :z-index="9999"
  >
    <v-icon left color="white">mdi-information</v-icon>
    {{ snackbarText }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="snackbar = false" color="white">
        Zatvori
      </v-btn>
    </template>
  </v-snackbar>
  </div>
</template>

<script>
import state from '@/state'
import { df, functions } from '@/plugins/firebase'
import AccountDetailsDialogNew from '@/modules/cash-register/components/dialogs/AccountDetailsDialogNew.vue'

export default {
  components: {
    AccountDetailsDialogNew
  },

  inject: ['showMsgBox'],

  data () {
    return {
      dialogOpen: false,
      receipt: {},
      receiptType: null,
      snackbar: false,
      snackbarText: '',
      loading: false // NOVI - za loading state tijekom receiptapi poziva
    }
  },
  methods: {
    open (receipt) {
      this.receipt = receipt
      this.receiptType = receipt.type.flag
      this.dialogOpen = true
    },
    refresh (type) {
      this.receipt.type = type
      this.close()
    },

    onSuccess (message) {
      this.snackbarText = message
      this.snackbar = true
    },

    onShowSnackbar ({ text, color }) {
      this.snackbarText = text
      this.snackbarColor = color
      this.snackbar = true
    },

    close () {
      this.dialogOpen = false
    },

    changeReceiptType () {
      // receiptType is the NEW selected value from radio button
      switch (this.receiptType) {
        case 'R': // Changed to R1
          this.changeToR1()
          break
        case 'BO': // Changed to BO
          this.changeToBO()
          break
      }
    },

    changeToR1 () {
      this.$refs.accountDetailsDialog.open(this.receipt)
      // this.close()
    },

    // Provjeri da li je račun fiskaliziran
    isFiscalized () {
      return this.receipt.fiscalize === true && this.receipt.zki !== ''
    },

    // Provjeri da li je račun transakcijski
    isTransactional () {
      return this.receipt.payment_method === 'TRANSAKCIJSKI RAČUN'
    },

    // Pozovi receiptapi za brisanje OIB-a (promjena u BO)
    async callReceiptApiForRemoveOib () {
      const me = this
      const receiptApi = functions.httpsCallable('receiptapi')

      const params = {
        company_id: state.getCurrentCompany().id,
        payer_oib: '' // Prazan string - briše OIB
      }

      return receiptApi({
        action: {
          operation: 'update',
          entity: 'payment',
          resource_id: this.receipt.id,
          params: params
        }
      })
        .then((doc) => {
          const isError = (doc.header && doc.header.code !== 200) ||
                         (doc.data && doc.data.status !== 'OK' && doc.data.code !== 200)

          if (isError) {
            const errorMessage = (doc.data && doc.data.error) ||
                                (doc.header && doc.header.error) ||
                                'Promjena u "Bez oznake" nije uspjela.'
            me.showMsgBox({
              title: 'Greška pri promjeni oznake',
              text: errorMessage,
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
            throw new Error(errorMessage)
          }

          return doc
        })
        .catch((error) => {
          console.error('receiptapi error:', error)
          throw error
        })
    },

    async changeToBO () {
      const me = this

      // Ako je već BO, samo zatvori
      if (this.receipt.type.flag === 'BO') {
        this.close()
        return
      }

      // NOVA LOGIKA: Provjeri da li treba pozvati receiptapi
      const needsReceiptApi = this.isFiscalized() && !this.isTransactional()

      try {
        // AKO treba receiptapi, prvo pozovi ga
        if (needsReceiptApi) {
          me.loading = true // Prikaži loading
          await this.callReceiptApiForRemoveOib()
        }

        // receiptapi je prošao OK (ili nije bio potreban)
        // Sada uradi Firestore update (kao i do sada)
        df.doc(`receipts/${state.getCurrentCompany().id}/receipts/${this.receipt.id}`).update({
          type: {
            flag: 'BO'
          }
        })
          .then(() => {
            console.info('Receipt succesfully updated')
            me.receipt.type.flag = 'BO'
            me.loading = false
            me.snackbarText = 'Oznaka uspješno promijenjena u "Bez oznake"'
            me.snackbar = true
            me.close()
          })
          .catch((error) => {
            console.error('Firestore update error:', error)
            me.loading = false
            me.showMsgBox({
              text: 'Pogreška prilikom promjene oznake',
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
          })
      } catch (error) {
        // receiptapi je failao - ne nastavljamo sa Firestore update-om
        console.error('receiptapi failed, aborting:', error)
        me.loading = false
        // showMsgBox je već prikazan u callReceiptApiForRemoveOib
      }
    }
  }

}
</script>

<style scoped>
/* Glass Card with Brand Gradient Header */
.glass-card-receipt-type {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.15) !important;
  overflow: hidden;
}

.glass-header-receipt-type {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.9) 0%,
    rgba(57, 137, 201, 0.85) 50%,
    rgba(97, 84, 164, 0.9) 100%) !important;
  position: relative;
}

/* Customer Information Section */
.customer-info-section {
  margin-bottom: 16px;
}

.customer-info-label {
  font-size: 12px;
  color: rgba(57, 137, 201, 0.8);
  font-weight: 500;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.customer-info-card {
  background: rgba(57, 137, 201, 0.08);
  border-radius: 12px;
  border: 1px solid rgba(57, 137, 201, 0.2);
  padding: 12px;
}

.info-label {
  font-size: 11px;
  color: rgba(57, 137, 201, 0.7);
  font-weight: 500;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.info-value {
  font-weight: 600;
  color: rgba(70, 70, 80, 0.9);
  font-size: 14px;
  line-height: 1.4;
}

.edit-customer-btn {
  background: rgba(255, 255, 255, 0.9) !important;
  color: #3989C9 !important;
  border: 1px solid rgba(57, 137, 201, 0.25) !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.12) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  padding: 8px 16px !important;
  height: auto !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.edit-customer-btn:hover {
  background: rgba(57, 137, 201, 0.1) !important;
  border-color: rgba(57, 137, 201, 0.4) !important;
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.2) !important;
  transform: translateY(-2px);
}

/* Receipt Type Selection */
.receipt-type-label {
  font-size: 13px;
  font-weight: 600;
  color: rgba(57, 137, 201, 0.8);
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin-bottom: 12px;
}

.receipt-type-radio {
  margin-top: 0;
  padding-top: 0;
}

.receipt-radio-item {
  margin-bottom: 12px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 12px;
  border: 2px solid rgba(57, 137, 201, 0.15);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.receipt-radio-item:hover {
  background: rgba(57, 137, 201, 0.08);
  border-color: rgba(57, 137, 201, 0.3);
  transform: translateX(4px);
}

.receipt-radio-item >>> .v-radio {
  align-items: flex-start !important;
}

.radio-label-content {
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding-left: 8px;
}

.radio-title {
  font-size: 15px;
  font-weight: 600;
  color: rgba(70, 70, 80, 0.9);
  letter-spacing: 0.3px;
  margin-bottom: 2px;
}

.radio-subtitle {
  font-size: 12px;
  color: rgba(57, 137, 201, 0.7);
  font-weight: 400;
  letter-spacing: 0.2px;
}

/* Selected Radio Item */
.receipt-radio-item >>> .v-item--active {
  background: rgba(57, 137, 201, 0.12) !important;
  border-color: rgba(57, 137, 201, 0.5) !important;
}

/* Cancel Button */
.cancel-btn-receipt-type {
  background: rgba(255, 255, 255, 0.9) !important;
  color: #3989C9 !important;
  border: 1px solid rgba(57, 137, 201, 0.25) !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.12) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  padding: 10px 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.cancel-btn-receipt-type:hover {
  background: rgba(57, 137, 201, 0.1) !important;
  border-color: rgba(57, 137, 201, 0.4) !important;
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.2) !important;
  transform: translateY(-2px);
}
</style>
